import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import { FastField, Field, Form, Formik } from 'formik';
import Checkbox from '@/trio-ui/Checkbox';
import DropDown from '@/trio-ui/Dropdown';
import Textarea from '@/trio-ui/Textarea';
import TransparentButton from '@/trio-ui/TransparentButton';
import { expertiseSchema } from '@/utils/candidate';
import { yearsOfExperienceOptions } from '@/utils/dropdownOptions';
import { buildErrorMessage } from '@/utils/formsValidation';
import * as Styles from './CandidateExpertiseItem.styles';
import TechnologiesDropdown from '../TechnologiesDropdown';

type CandidateExpertiseItemComponentProps = {
  id?: string;
  skillId?: string;
  experience: string;
  description: string;
  isMainStack: boolean;
  tags: string[];
  onSaveExpertise: (values: any) => void;
  onCancelExpertiseEdition: () => void;
};

const CandidateExpertiseItemComponent = ({
  description,
  id,
  skillId,
  experience,
  isMainStack,
  tags,
  onSaveExpertise,
  onCancelExpertiseEdition,
}: CandidateExpertiseItemComponentProps): JSX.Element => {
  return (
    <Styles.Box>
      <Formik
        validationSchema={expertiseSchema}
        initialValues={{
          skillId,
          description,
          experience,
          tags,
          isMainStack,
        }}
        onSubmit={(values) => onSaveExpertise(values)}
      >
        {(form) => {
          return (
            <Form>
              <Styles.Row>
                <div style={{ width: '50%' }}>
                  <FastField name="skillId">
                    {({ field }) => {
                      return (
                        <TechnologiesDropdown
                          isDisabled={!!id}
                          label="Name"
                          name="skillId"
                          defaultValue={field.value}
                          onChange={form.handleChange}
                          errorMessage={buildErrorMessage(
                            form.touched.skillId,
                            form.errors.skillId
                          )}
                        />
                      );
                    }}
                  </FastField>
                </div>
                <div style={{ width: '50%' }}>
                  <Field name="experience">
                    {({ field }) => (
                      <DropDown
                        label="Experience"
                        name="experience"
                        isLabelAboveField
                        defaultValue={field.value}
                        onChangeDropDown={form.handleChange}
                        errorMessage={buildErrorMessage(
                          form.touched.experience,
                          form.errors.experience
                        )}
                        options={yearsOfExperienceOptions}
                      />
                    )}
                  </Field>
                </div>
              </Styles.Row>

              <FastField name="description">
                {({ field }) => (
                  <Textarea
                    name="description"
                    label="Description"
                    onChange={form.handleChange}
                    errorMessage={buildErrorMessage(
                      form.touched.description,
                      form.errors.description
                    )}
                    value={field.value}
                  />
                )}
              </FastField>

              <div style={{ marginBottom: '16px' }}>
                <Field name="tags">
                  {({ field }) => (
                    <TechnologiesDropdown
                      label="Related Technologies"
                      name="tags"
                      isMulti
                      closeMenuOnSelect={false}
                      defaultValue={field.value}
                      onChange={form.handleChange}
                      errorMessage={buildErrorMessage(form.touched.tags, form.errors.tags)}
                    />
                  )}
                </Field>
              </div>

              <Field name="isMainStack">
                {({ field }) => {
                  return (
                    <Checkbox
                      label="Is main stack"
                      checked={field.checked || field.value}
                      name="isMainStack"
                      onChangeHandler={form.handleChange}
                      errorMessage={buildErrorMessage(
                        form.touched.isMainStack,
                        form.errors.isMainStack
                      )}
                    />
                  );
                }}
              </Field>

              <div className="flex" style={{ gap: 16 }}>
                <TransparentButton isBlueButton icon={SaveIcon} type="submit">
                  Save
                </TransparentButton>
                <TransparentButton
                  type="button"
                  icon={DeleteIcon}
                  isRedButton
                  onClick={() => {
                    onCancelExpertiseEdition();
                    form.resetForm();
                  }}
                >
                  Cancel
                </TransparentButton>
              </div>

              <Styles.Divider />
            </Form>
          );
        }}
      </Formik>
    </Styles.Box>
  );
};

export default CandidateExpertiseItemComponent;
